/* eslint-disable import/prefer-default-export,react/no-danger */
import React from 'react';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';

export const StatusBanner = ({
  statusBannerTitle,
  statusBannerMainText,
  setShowingStatusBanner,
  isShowingStatusBanner,
  statusBannerIsOptional,
  statusBannerAdditional,
}) => {
  if (isMobile) {
    return (
      <div className="w-100 bg-white pt-1 pb-1">
        <div className="container d-flex h-100 p-3 text-f6 flex-column text-grey-light position-relative">
          <div className="col-12 flex-wrap text-bold mb-2  d-flex">
            {statusBannerTitle && (
              <>
                <i className="icon icon-info-icon  me-2 mt-1" />
                <div dangerouslySetInnerHTML={{ __html: statusBannerTitle }} />
              </>
            )}
          </div>
          <div className="col-12 d-flex justify-content-center align-content-center">
            <div>
              <div className="text-bold mb-1">
                {statusBannerMainText && (
                  <div dangerouslySetInnerHTML={{ __html: statusBannerMainText }} />
                )}
              </div>
              {statusBannerAdditional && (
                <div dangerouslySetInnerHTML={{ __html: statusBannerAdditional }} />
              )}
            </div>
          </div>
          {statusBannerIsOptional && (
            <div className="position-absolute top-20" style={{ right: '5%' }}>
              <i
                onClick={() => setShowingStatusBanner(!isShowingStatusBanner)}
                onKeyDown={() => setShowingStatusBanner(!isShowingStatusBanner)}
                role="button"
                className="close-btn text-f5 text-bold cursor-pointer icon icon-close-other text-shadow"
                tabIndex={-1}
                aria-label="Close"
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="w-100 bg-white pt-2 pb-2 ">
      <div className="container d-flex text-f6 text-grey-light align-content-center justify-content-center flex-wrap">
        {statusBannerTitle && (
          <div className="col-lg-4 col-md-3 col-sm-3  flex-wrap text-bold d-flex justify-content-center align-content-center">
            <i className="icon icon-info-icon  me-2 mt-1" />

            <div dangerouslySetInnerHTML={{ __html: statusBannerTitle }} />
          </div>
        )}
        <div
          className={` flex-wrap  d-flex justify-content-center align-content-center
              ${statusBannerTitle ? 'col-lg-6 col-md-7  col-sm-8' : 'col-lg-10 col-md-10'}`}>
          <div>
            <div className="text-bold">
              {statusBannerMainText && (
                <div dangerouslySetInnerHTML={{ __html: statusBannerMainText }} />
              )}
            </div>
            {statusBannerAdditional && (
              <div dangerouslySetInnerHTML={{ __html: statusBannerAdditional }} />
            )}
          </div>
        </div>
        {statusBannerIsOptional && (
          <div className="col-lg-2 col-md-2  col-sm-1 flex-wrap d-flex justify-content-center align-content-center">
            <i
              onClick={() => setShowingStatusBanner(!isShowingStatusBanner)}
              onKeyDown={() => setShowingStatusBanner(!isShowingStatusBanner)}
              role="button"
              className="close-btn text-f5 cursor-pointer icon icon-close-other text-shadow"
              tabIndex={-1}
              aria-label="Close"
            />
          </div>
        )}
      </div>
    </div>
  );
};

StatusBanner.propTypes = {
  statusBannerTitle: PropTypes.string.isRequired,
  statusBannerMainText: PropTypes.string.isRequired,
  statusBannerAdditional: PropTypes.string,
  isShowingStatusBanner: PropTypes.bool,
  statusBannerIsOptional: PropTypes.bool,
  setShowingStatusBanner: PropTypes.func,
};

StatusBanner.defaultProps = {
  statusBannerAdditional: null,
  statusBannerIsOptional: false,
  isShowingStatusBanner: false,
  setShowingStatusBanner: () => {},
};
